import { Card, Typography, Button, Pagination } from "antd";
import { PlusOutlined } from "@ant-design/icons";
import { useEffect, useState } from "react";
import TableRows from "./TableRows";
import AddInstitutes from "../../Modal/AddInstitutes";
import { getData } from "../../utils";

const ManageInstitutes = () => {
  const [add, setAdd] = useState(false);
  const [data, setData] = useState([]);
  const [page, setPage] = useState(1);
  const [total, setTotal] = useState(0);

  const getList = async () => {
    try {
      let res = await getData(`/v1/admin/institution/get?page=${page}`, true);
      if (res.status === "success") {
        setData(res.data);
        setTotal(res.total);
      }
    } catch (e) {}
  };

  useEffect(() => {
    getList();
  }, [page]);

  return (
    <>
      <Card>
        <div className="flex justify-between items-center mb-4 gap-3">
          <Typography className="text-xl font-semibold" align={"left"}>
            Manage Institutes
          </Typography>
          <div className="flex justify-end gap-3">
            <Button
              type="primary"
              icon={<PlusOutlined />}
              size={14}
              onClick={() => {
                setAdd(true);
              }}
            >
              Add institute
            </Button>
          </div>
        </div>
        <div className="relative overflow-x-auto">
          <table className="w-full text-sm text-left text-gray-500">
            <thead className="text-xs text-gray-700 bg-gray-50">
              <tr>
                <th scope="col" className="px-3 py-3">
                  Institute name
                </th>
                <th scope="col" className="px-3 py-3">
                  Institute domain
                </th>
                <th scope="col" className="px-3 py-3">
                  Last updated date
                </th>
                <th scope="col" className="px-3 py-3">
                  Status
                </th>
                <th scope="col" className="px-3 py-3">
                  Number of users{" "}
                </th>
                <th scope="col" className="px-3 py-3">
                  Action
                </th>
              </tr>
            </thead>
            <tbody>
              {data.map((element, ind) => {
                return (
                  <TableRows
                    rows={element}
                    key={ind}
                    callback={() => {
                      getList();
                    }}
                  />
                );
              })}
            </tbody>
          </table>
        </div>
        <div className="flex justify-between items-center mt-4">
          <div className="text-base font-semibold">
            Total Institutes - <span className="font-normal">{total}</span>
          </div>
          <Pagination defaultCurrent={page} total={total} onChange={(e) => setPage(e)} />
        </div>
      </Card>

      {add ? (
        <AddInstitutes
          isOpen={true}
          onCancel={() => setAdd(false)}
          callback={() => {
            setAdd(false);
            getList();
          }}
        />
      ) : null}
    </>
  );
};

export default ManageInstitutes;
